import classNames from 'classnames';
import { SectionHeader, Input, UserInfoCard } from '@pentabd/ui';
import { IconEdit05, IconSearch } from '@pentabd/icons';

const NotificationPanel = ({ userInfo, handleSelected, selected }: any) => {
  return (
    <div className="w-100 border-end h-100 d-dlex flex-column">
      <div className="pe-9 pointer">
        <SectionHeader
          title="Notifications"
          components={[
            <div>
              <IconEdit05 size="24" stroke="subtitle2" />
            </div>,
          ]}
        />
      </div>
      <div className="pe-9 pb-6">
        <Input
          name="search"
          placeholder="Search"
          prefix={<IconSearch size="24" stroke="dark" />}
        ></Input>
      </div>
      <div>
        {userInfo?.map((item: any, index: number) => {
          return (
            <div
              key={index}
              className={classNames('border-bottom py-9 pointer', {
                'selected-notification': selected?.id === item.id,
              })}
              onClick={() => handleSelected(item.id)}
            >
              <UserInfoCard
                className="pe-9"
                title={item.title}
                subtitle={item.subtitle}
                subtitle2={item.subtitle2}
                imageURL={item.imageURL}
                badge={{
                  label: item.badge.label,
                  type: 'primary',
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default NotificationPanel;
